// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__3HMgQ","colMin":"styles_colMin__3aj_u","colCheckbox":"styles_colCheckbox__1JPWd"};